"use client";

import { useEffect, useRef } from "react";


export default function ContactBanner() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.1 }
    );
    const items = ref?.current?.querySelectorAll(".reveal");
    items?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="contacto" ref={ref} className="py-28 px-6 lg:px-10 bg-evolvia-bg-light relative overflow-hidden">
      {/* Top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-evolvia-copper/20 to-transparent" />
      {/* Geometric accent */}
      <div className="absolute inset-0 dot-grid-light opacity-40" />
      <div className="max-w-4xl mx-auto relative z-10 text-center">
        {/* Geometric lines */}
        <div className="flex items-center justify-center gap-4 mb-8 reveal">
          <div className="h-px flex-1 max-w-24 bg-evolvia-copper/30" />
          <div className="w-2 h-2 rotate-45 border border-evolvia-copper" />
          <div className="h-px flex-1 max-w-24 bg-evolvia-copper/30" />
        </div>

        <div className="reveal">
          <span className="text-xs font-700 uppercase tracking-[0.25em] text-evolvia-copper mb-4 block">
            Hablemos
          </span>
          <h2 className="text-5xl md:text-6xl font-black leading-[0.92] tracking-tight text-evolvia-text-dark mb-6">
            ¿Tienes un proyecto
            <br />
            <span className="gradient-text-copper">en mente?</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto leading-relaxed mb-10">
            Cuéntanos tu idea y recibirás un presupuesto personalizado sin compromiso en menos de 24 horas.
            Estamos en Las Palmas de Gran Canaria, listos para hacer realidad tu visión.
          </p>
        </div>

        <div className="reveal delay-200 flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a href="mailto:hola@evolvia3d.es" className="btn-primary">
            Contactar ahora
          </a>
          <a href="tel:+34600000000" className="btn-outline-dark">
            +34 600 000 000
          </a>
        </div>

        {/* Contact details */}
        <div className="reveal delay-300 flex flex-wrap justify-center gap-8">
          {[
            { icon: "✉", label: "hola@evolvia3d.es", href: "mailto:hola@evolvia3d.es" },
            { icon: "📍", label: "Las Palmas de Gran Canaria", href: "#" },
            { icon: "⏱", label: "Respuesta en 24h", href: "#" },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              className="flex items-center gap-2 text-sm text-gray-500 hover:text-evolvia-copper transition-colors"
            >
              <span>{item?.icon}</span>
              <span>{item?.label}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
